export { default } from './BrandingFooter';
